import { inRn, mString, pm } from 'lib/helpers/utility';

import ServiceDetails from '../ServiceDetails';

export const ITEMS_TABLE_COLUMNS = (userPermissions, isPatient, hasItems) => [
  {
    headerName: 'Service description',
    field: 'name',
    width: '50%',
    cellRenderer: ({ data }) => {
      if (hasItems) {
        return <ServiceDetails service={data} />;
      }

      return 'Sale';
    }
  },
  {
    headerName: 'Price',
    field: 'price',
    valueFormatter: ({ value }) => mString(inRn(value)),
    aggFunc: 'sum',
    width: '10%',
    hide: isPatient ? false : !pm(userPermissions, 'payments.read') || !hasItems
  },
  {
    headerName: 'Qty',
    field: 'quantity',
    valueFormatter: ({ value }) => inRn(value, 1),
    aggFunc: 'sum',
    width: '10%',
    hide: !hasItems
  },
  {
    headerName: 'Discount',
    field: 'discount',
    valueFormatter: ({ value }) => mString(inRn(value)),
    aggFunc: 'sum',
    width: '10%',
    hide: !hasItems
  },
  {
    headerName: 'Tax',
    field: 'tax',
    valueFormatter: ({ value }) => mString(inRn(value)),
    aggFunc: 'sum',
    width: '10%',
    hide: !hasItems
  },
  {
    headerName: hasItems ? 'Total' : 'Charge',
    field: hasItems ? 'total' : 'charge',
    valueFormatter: ({ value }) => mString(inRn(value)),
    aggFunc: 'sum',
    width: '10%',
    hide: isPatient ? false : !pm(userPermissions, 'payments.read')
  }
];

export const MOBILE_ITEMS_TABLE_COLUMNS = [
  {
    headerName: 'Service',
    field: 'name'
  }
];
